import React from 'react'

/**
 * Minute Circles needs to work a bit differently from HourCircle due to overlapping.
 * 
 * @param {*} props 
 */
const MinuteCircle =(props)=> {
  let classes = props.selected
    ? "time-circle noselect colors-fill-primary"
    : "time-circle noselect"

  let content = null;

  if (!props.subMinute){
    classes += " time-circle-number"
    content = (<div className="time-circle-number">{props.number}</div>)
  }
  else if (props.selected){
    content = (<div className="time-circle-dot"/>)
  }
  else {
    content = (<div className="time-circle-dot-hidden"/>)
  }

  return (
    <div
      className={classes} 
      onClick={(event) => props.clicked(props.number,event)}
      style={{ 
        left: (props.x -16) +"px",
        top: (props.y -16) +"px",}}>
      {content}
    </div>
  )
}

export default MinuteCircle